import {
  FacebookServices as Facebook,
  GoogleServices as Google,
} from '@clearkit/icons';

import Conversions from '~/images/planGates/increase_conversion_rates.svg';
import { segmentTypes } from '~/lib/segments';

import { useHasConversionsAccess } from '../../../../hooks/account/usePlatformAccess';
import AddPlanPanel from './AddPlanPanel';
import { AddPlanProps } from './types';

function AddConversionsPlan({ segment }: AddPlanProps) {
  const hasConversionsPlan = useHasConversionsAccess();

  if (segment.type === segmentTypes.company || hasConversionsPlan) {
    return null;
  }

  const destinations = [
    {
      name: 'Offline conversion events',
      description: 'Optimize your ad spend',
      icon: <Conversions className="w-8 h-8 mr-3" />,
    },
  ];

  return (
    <AddPlanPanel
      description="Convert the visitors you care about most with shorter forms, dynamic content and CTAs designed for key audience segments."
      destinations={destinations}
      footerDescription="Optimize your website for conversion and send to your ads platform"
      footerIcons={[Facebook, Google]}
      title="Convert Intent"
    />
  );
}
export default AddConversionsPlan;
